export default __webpack_public_path__ + "_/images/bonuses/header/lightning-c3b042edd7f9a95f1621c476efc666587313b92814af0929d67deb1fed7d3d84.png";